/*
 * Cart drawer recommendations: add without leaving the drawer.
 * Intercepts the row's form submit, adds over the Cart AJAX API, and hands the returned sections to
 * Dawn's CartDrawer.renderContents() so the drawer re-renders in place and the added item leaves the list.
 * Delegated from document because renderContents() replaces the markup.
 */
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.cu-d__form');
  if (!form) return;
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
  event.preventDefault();
  const button = form.querySelector('.cu-d__btn');
  if (button) {
    if (button.hasAttribute('aria-disabled')) return;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('cu-d__btn--loading');
  }
  const body = new FormData(form);
  cartDrawer.getSectionsToRender().forEach((section) => body.append('sections[]', section.id));
  body.append('sections_url', window.location.pathname);
  try {
    const response = await fetch(`${routes.cart_add_url}`, { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body });
    const parsed = await response.json();
    if (parsed.status) { console.error('Cart upsell add failed:', parsed.description || parsed.message); return; }
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: parsed });
    cartDrawer.renderContents(parsed);
  } catch (error) {
    console.error('Cart upsell add failed:', error);
  } finally {
    if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('cu-d__btn--loading'); }
  }
});
